var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn-toggle',{staticClass:"pp-button-group",attrs:{"active-class":_vm.ppActiveClass,"value":_vm.item,"multiple":_vm.multiple,"mandatory":_vm.mandatory},on:{"change":_vm.onChange}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }